import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IllustrationEcard = function IllustrationEcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 140 140"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD7DF",
    d: "M132 31 58.425 89.7l32.913 26.6zm0 0L41.617 82.9 8 70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D53C62",
    d: "m41.617 82.9 5.536 38.1 11.272-31.3L132 31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M58.425 89.7 47.153 121l26.27-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "m63.251 85.224-9.18-36.778 48.23-27.692 7.59 27.261z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "m90.705 57.059 7.734-23.054-6.747 25.858-25.572-8.159 23.995 5.682.444.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD7DF",
    d: "M88.318 42.8c-.704-.2-1.51-.1-2.315.3-.201.1-.503.3-.704.5-.202.2-.403.4-.504.7-.1.2-.302.5-.402.7-.1.2-.201.4-.201.6-.202-.1-.403-.1-.604-.2-.202 0-.504-.1-.705-.1h-.805c-.302 0-.503.1-.805.2-.906.4-1.41 1-1.711 1.7-.302.7-.202 1.5.201 2.3.1.3.302.5.503.7.201.2.403.4.604.5.201.1.403.3.705.4.201.1.402.2.503.2.1 0 .201.1.201.1l5.234 1.7h.302c.1 0 .201-.1.201-.2l1.913-5.2c.402-1.3.503-2.4 0-3.2-.302-.9-.906-1.4-1.61-1.7"
  }));
};